export const findId: (<T extends { id?: number | string; }>(list: T[] | undefined, id?: number | string) => (T | undefined)) = (list, id) => {
  if (!list || id === undefined) {
    return undefined;
  }
  const temp = list.find((item, index) => item.id === id);
  return temp;
};
